import { Heart } from "lucide-react";
import Typography from "components/elements/Typography";
import classes from "./classes.module.scss";

type IProps = {
	likes: number;
};

export default function ProjectLike(props: IProps) {
	return (
		<div className={classes["root"]}>
			<Heart className={classes["icon"]} />
			<Typography type="p" weight="medium" size="small" color="white" className={classes["likes-count"]}>
				{props.likes}
			</Typography>
		</div>
	);
}
